// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.month-sort[data-v-75475e22].v-select__selection.v-select__selection--comma {\n  font-size: 12px !important;\n}\n.deep-ocean-font[data-v-75475e22] {\n  color: #003545;\n}", ""]);
// Exports
module.exports = exports;
